<div class="modal-container">
@if (! selectedResource) {
  <div class="relative-cont">
    <div class="export-button-cont">
      <awc-button
        class="add-new-button"
        [text]="'Add New'"
        [suffixIcon]="addIcon"
        [size]="buttonSize"
        (buttonClicked)="exportDirectToLibrary()"
      ></awc-button>
    </div>
    <awf-table [tableId]="dashboardTables.LIBRARY" (rowClick)="toggleSelection($event)" [(total)]="total" [style.height]="maxHeight()+'px'"></awf-table>
  </div>
} @else {
  <div class="relative-cont">
    <app-library-panel [resourceId]="selectedResource" (resourceLoaded)="setLibraryItemLoaded()"></app-library-panel>
    @if (libraryItemLoaded) {
      <div class="button-cont">
        <awc-button [type]="btnTypeSecondary" [text]="'Back'" [size]="buttonSize" (buttonClicked)="back()"></awc-button>
        <awc-button
          [text]="'Import'"
          [size]="buttonSize"
          (buttonClicked)="importResource(selectedResource)"
        ></awc-button>
      </div>
    } @else {
      <div class="loading-cont">
        <awc-icon [icon]="Icons.SPINNER"></awc-icon>
      </div>
    }
  </div>
}
</div>
